import { render, staticRenderFns } from "./BaseLikeButton.vue?vue&type=template&id=30f802cf&scoped=true&"
import script from "./BaseLikeButton.vue?vue&type=script&lang=js&"
export * from "./BaseLikeButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseLikeButton.vue?vue&type=style&index=0&id=30f802cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f802cf",
  null
  
)

export default component.exports